import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#asset-allocation-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#alloc-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const labelStocks = $container.data('label-stocks') || 'Акції (ETF)';
    const labelBonds = $container.data('label-bonds') || 'Облігації та ОВДП';
    const labelReit = $container.data('label-reit') || 'Нерухомість (REITs)';
    const labelGold = $container.data('label-gold') || 'Золото та Сировина';
    const labelCrypto = $container.data('label-crypto') || 'Криптовалюта';
    const labelCash = $container.data('label-cash') || 'Готівка';
    const unallocatedLabel = $container.data('unallocated-label') || 'Не розподілено';
    const portfolioLabel = $container.data('portfolio-label') || 'Портфель';

    const $capitalRange = $('#alloc-capital-range');
    const $capitalDisplay = $('#alloc-capital-display');
    const $presetSelect = $('#alloc-preset-select');

    const $stocksRange = $('#alloc-stocks-range');
    const $stocksDisplay = $('#alloc-stocks-display');

    const $bondsRange = $('#alloc-bonds-range');
    const $bondsDisplay = $('#alloc-bonds-display');

    const $reitRange = $('#alloc-reit-range');
    const $reitDisplay = $('#alloc-reit-display');

    const $goldRange = $('#alloc-gold-range');
    const $goldDisplay = $('#alloc-gold-display');

    const $cryptoRange = $('#alloc-crypto-range');
    const $cryptoDisplay = $('#alloc-crypto-display');

    const $cashRange = $('#alloc-cash-range');
    const $cashDisplay = $('#alloc-cash-display');

    const presets = {
        conservative: { stocks: 20, bonds: 60, reit: 0, gold: 0, crypto: 0, cash: 20 },
        balanced: { stocks: 60, bonds: 30, reit: 0, gold: 10, crypto: 0, cash: 0 },
        growth: { stocks: 80, bonds: 15, reit: 0, gold: 0, crypto: 5, cash: 0 },
        aggressive: { stocks: 90, bonds: 0, reit: 0, gold: 0, crypto: 10, cash: 0 },
        allweather: { stocks: 30, bonds: 55, reit: 0, gold: 15, crypto: 0, cash: 0 }
    };

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const capital = parseFloat($capitalRange.val()) || 50000;
        $capitalDisplay.text(formatMoney(capital));

        const stocksPct = parseFloat($stocksRange.val()) || 0;
        const bondsPct = parseFloat($bondsRange.val()) || 0;
        const reitPct = parseFloat($reitRange.val()) || 0;
        const goldPct = parseFloat($goldRange.val()) || 0;
        const cryptoPct = parseFloat($cryptoRange.val()) || 0;
        const cashPct = parseFloat($cashRange.val()) || 0;

        $stocksDisplay.text(stocksPct + '%');
        $bondsDisplay.text(bondsPct + '%');
        $reitDisplay.text(reitPct + '%');
        $goldDisplay.text(goldPct + '%');
        $cryptoDisplay.text(cryptoPct + '%');
        $cashDisplay.text(cashPct + '%');

        const totalPct = stocksPct + bondsPct + reitPct + goldPct + cryptoPct + cashPct;
        const $badge = $('#alloc-total-badge');
        $badge.text(totalPct + '%');

        if (totalPct === 100) {
            $badge.removeClass('bg-danger bg-warning').addClass('bg-success');
        } else if (totalPct > 100) {
            $badge.removeClass('bg-success bg-warning').addClass('bg-danger');
        } else {
            $badge.removeClass('bg-success bg-danger').addClass('bg-warning');
        }

        // Expected metrics
        const weightedCagr = (stocksPct * 9.5 + bondsPct * 4.5 + reitPct * 7.5 + goldPct * 5.0 + cryptoPct * 20.0 + cashPct * 2.0) / (totalPct || 100);
        const weightedDrawdown = (stocksPct * -50.0 + bondsPct * -12.0 + reitPct * -42.0 + goldPct * -22.0 + cryptoPct * -80.0 + cashPct * 0.0) / (totalPct || 100);

        $('#alloc-kpi-cagr').text(weightedCagr.toFixed(1) + '%');
        $('#alloc-kpi-drawdown').text(weightedDrawdown.toFixed(1) + '%');

        const stocksAmt = capital * (stocksPct / 100);
        const safetyAmt = capital * ((bondsPct + goldPct + cashPct) / 100);

        $('#alloc-kpi-stocks').text(formatMoney(stocksAmt));
        $('#alloc-kpi-safety').text(formatMoney(safetyAmt));

        // Render money breakdown
        const items = [
            { name: labelStocks, pct: stocksPct, amt: stocksAmt, color: '#556ee6' },
            { name: labelBonds, pct: bondsPct, amt: capital * (bondsPct / 100), color: '#34c38f' },
            { name: labelGold, pct: goldPct, amt: capital * (goldPct / 100), color: '#f1b44c' },
            { name: labelReit, pct: reitPct, amt: capital * (reitPct / 100), color: '#50a5f1' },
            { name: labelCrypto, pct: cryptoPct, amt: capital * (cryptoPct / 100), color: '#f46a6a' },
            { name: labelCash, pct: cashPct, amt: capital * (cashPct / 100), color: '#74788d' }
        ];

        let html = '';
        items.filter(i => i.pct > 0).forEach(i => {
            html += `
                <div class="col-sm-4 col-6">
                    <div class="p-2 border rounded bg-light">
                        <div class="font-size-11 text-muted text-truncate" title="${i.name}">${i.name}</div>
                        <div class="fw-bold font-size-13" style="color: ${i.color}">${formatMoney(i.amt)} (${i.pct}%)</div>
                    </div>
                </div>`;
        });
        $('#alloc-breakdown-container').html(html);

        // Chart series
        const seriesData = [];
        const labelsData = [];
        const colorsData = [];

        items.forEach(i => {
            if (i.pct > 0) {
                seriesData.push(i.pct);
                labelsData.push(i.name);
                colorsData.push(i.color);
            }
        });

        renderChart(seriesData, labelsData, colorsData);
    }

    function renderChart(seriesData, labelsData, colorsData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: seriesData.length ? seriesData : [100],
            labels: labelsData.length ? labelsData : [unallocatedLabel],
            colors: colorsData.length ? colorsData : ['#74788d'],
            chart: {
                type: 'donut',
                height: 290
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '68%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                color: isDark ? '#a6b0cf' : '#495057'
                            },
                            value: {
                                show: true,
                                formatter: function (val) {
                                    return val + '%';
                                },
                                color: isDark ? '#a6b0cf' : '#495057'
                            },
                            total: {
                                show: true,
                                label: portfolioLabel,
                                color: isDark ? '#a6b0cf' : '#495057',
                                formatter: function () {
                                    return '100%';
                                }
                            }
                        }
                    }
                }
            },
            dataLabels: { enabled: false },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            }
        };

        const chartEl = document.querySelector('#asset-allocation-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Preset Change
    $presetSelect.on('change', function () {
        const val = $(this).val();
        if (presets[val]) {
            const p = presets[val];
            $stocksRange.val(p.stocks);
            $bondsRange.val(p.bonds);
            $reitRange.val(p.reit);
            $goldRange.val(p.gold);
            $cryptoRange.val(p.crypto);
            $cashRange.val(p.cash);
            calculate();
        }
    });

    // Slider inputs
    $('.alloc-slider').on('input', function () {
        $presetSelect.val('custom');
        calculate();
    });

    $capitalRange.on('input', calculate);

    // Currency Switcher
    function setAllocCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#alloc-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.alloc-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.alloc-more-currencies-btn').addClass('active');
            $('#alloc-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#alloc-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.alloc-more-currencies-btn').removeClass('active');
            $('.alloc-currency-dropdown-item').removeClass('active');
            $('#alloc-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defCapital = parseFloat($(btn).data('capital')) || 50000;
        $capitalRange.val(defCapital);

        if (currency === 'UAH' || currency === 'CZK') {
            $capitalRange.attr({ min: 50000, max: 20000000, step: 50000 });
        } else if (currency === 'PLN') {
            $capitalRange.attr({ min: 10000, max: 2000000, step: 10000 });
        } else {
            $capitalRange.attr({ min: 1000, max: 500000, step: 1000 });
        }

        calculate();
    }

    $('#alloc-currency-tabs > button[data-currency-code]').on('click', function () {
        setAllocCurrency(this, false);
    });

    $(document).on('click', '.alloc-currency-dropdown-item', function (e) {
        e.preventDefault();
        setAllocCurrency(this, true);
    });

    calculate();
});

